export default {
  initialData: {
    basepath: ``,
    currents: [],
    currentsResources: [],
    styles: [],
    durations: [],
    equipment: [],
    focus: [],
    levels: [],
    teachers: [],
    seriesContent: "",
    collectionsContent: "",
    seriesCategories: [],
    popular: []
  },
  videos: [],
  series: [],
  flashMessage: {
    message: ``,
    visible: false
  },
  user: {
    isLoggedIn: ``,
    level: ``,
    name: ``,
    email: ``,
    myVideos: [],
    history: [],
    mySeries: [],
    seriesHistory: [],
    playlists: [],
    currentPlaylist: {
      id: '0',
      title: '',
      videos: [],
      series: [],
      collections: []
    },
    playlistSelected: '0',
    myViews: [],
    totalViews: 0,
    myTeachers: ``,
    accountStatus: ``,
    nextPayment: ``,
    subType: ``,
    hasToken: false,
    emailConfig: [
      {
        id: 1,
        label: `מעוניין לקבל את הניוזלטר החודשי`,
        selected: false
      },
      {
        id: 2,
        label: `שילחו לי מידע על מבצעים`,
        selected: false
      },
      {
        id: 3,
        label: `מעוניין לקבל התראות על תוכן חדש`,
        selected: false
      }
    ],
    remindersConfig: [
      {
        id: 1,
        label: `יום א’`,
        selected: false
      },
      {
        id: 2,
        label: `יום ב’`,
        selected: false
      },
      {
        id: 3,
        label: `יום ג’`,
        selected: false
      },
      {
        id: 4,
        label: `יום ד’`,
        selected: false
      },
      {
        id: 5,
        label: `יום ה’`,
        selected: false
      },
      {
        id: 6,
        label: `יום ו’`,
        selected: false
      },
      {
        id: 7,
        label: `יום ש’`,
        selected: false
      }
    ],
    xpConfig: [
      {
        id: 1,
        label: `שיעורי מתחילים`,
        selected: false
      },
      {
        id: 2,
        label: `שיעורי ממשיכים`,
        selected: false
      },
      {
        id: 3,
        label: `שיעורים למתקדמים`,
        selected: false
      }
    ],
    interestConfig: [
      {
        id: 1,
        label: `פשוט לתרגל- אני רוצה שיעורים זורמים ומצוינים שמתאימים לרמה שלי`,
        selected: false,
        focusId: [11]
      },
      {
        id: 2,
        label: `חיזוק, כושר וחיטוב`,
        selected: false,
        focusId: [1]
      },
      {
        id: 3,
        label: `שיפור גמישות, מתיחות וטווחי תנועה`,
        selected: false,
        focusId: [2, 8]
      },
      {
        id: 4,
        label: `תרגול מותאם לגיל השלישי`,
        selected: false,
        focusId: [3]
      },
      {
        id: 5,
        label: `שיפור שיווי המשקל, אימון פונקציונאלי ומיומנויות תנועה`,
        selected: false,
        focusId: [4, 10]
      },
      {
        id: 6,
        label: `התרעננות מישיבה ממושכת במהלך יום העבודה`,
        selected: false,
        focusId: [5]
      },
      {
        id: 7,
        label: `להפחית מתחים נפשיים ולהגביר את השלווה`,
        selected: false,
        focusId: [6, 9]
      },
      {
        id: 8,
        label: `הפחתת כאבים ו/או שיקום ממצב רפואי`,
        selected: false,
        focusId: [7]
      }
    ],

    cancelConfig: [
      {
        id: 1,
        label: `לא מצאתי את השיעורים שחיפשתי`,
        selected: false
      },
      {
        id: 2,
        label: `השיעור שבחרתי לא היה מוצלח`,
        selected: false
      },
      {
        id: 3,
        label: `לא מצאתי זמן להתשמש באתר yogaNow`,
        selected: false
      },
      {
        id: 4,
        label: `היו לי בעיות טכניות בשימוש באתר`,
        selected: false
      }
    ],
    currentConfig: [
      {
        id: 1,
        label: `יוגה`,
        selected: false,
        metaId: 1
      },
      {
        id: 2,
        label: `פילאטיס מזרן`,
        selected: false,
        metaId: 2
      },
      {
        id: 3,
        label: `פילאטיס מכשירים`,
        selected: false,
        metaId: 3
      },
      {
        id: 4,
        label: `סגנונות נוספים: פלדנקרייז, פלייסטיק, גי'רוקנסיס`,
        selected: false,
        metaId: 5
      },
      {
        id: 5,
        label: `מדיטציה, נשימה ודמיון מודרך`,
        selected: false,
        metaId: 4
      },
      {
        id: 6,
        label: `שיעורים רכים ושיקומיים`,
        selected: false,
        metaId: 6
      },
      {
        id: 7,
        label: `שיעורים לתקופת הריון ואחרי לידה`,
        selected: false,
        metaId: 7
      },
      {
        id: 8,
        label: `תרגול לילדים ולמשפחה`,
        selected: false,
        metaId: 8
      }
    ],
    durationConfig: [
      {
        id: 1,
        label: `עד 10 דקות`,
        selected: false
      },
      {
        id: 2,
        label: `10-20 דקות`,
        selected: false
      },
      {
        id: 3,
        label: `20-40 דקות`,
        selected: false
      },
      {
        id: 4,
        label: `40-60 דקות`,
        selected: false
      },
      {
        id: 5,
        label: `60 דקות ומעלה`,
        selected: false
      }
    ],
    tempoConfig: [
      {
        id: 1,
        label: `דינאמי ומהיר`,
        selected: false
      },
      {
        id: 2,
        label: `מתון ומרענן`,
        selected: false
      },
      {
        id: 3,
        label: `איטי ורגוע`,
        selected: false
      }
    ],
    styleConfig: []
  },
  sort: {
    selected: {},
    term: ``,
    results: [],
    showSpinner: false,
    showNoResults: false,
    errors: [],
    sortby: 1,
    page: 1
  },
  errors: [],
  teacherFeedback: {
    showSpinner: false,
    error: false,
    sending: false
  }
};
